import React from "react";


export default function ContentBannerComponent({className}: {className?: string}) {
    return (
        <div className={`w-full h-[70px] md:h-[150px] lg:h-[210px] bg-cover blur-lg bg-center ${className}`}
             style={{backgroundImage: 'URL("/imgs/banner.jpg")'}}/>
    )
}